// envConfig.js

const eemsURL = {
  stage: 'https://ees-stage1.optum.com/eems/',
  adop: 'https://eems-adoption.optum.com/eems/',
  prod: 'https://employereservices.optum.com/eems/',
};

const serviceURL = {
  uata: 'https://eems-online-uata.optum.com/',
  uatb: 'https://eems-online-uatb.optum.com/',
  sita: 'https://eems-online-sita.optum.com/',
  sitb: 'https://eems-online-sitb.optum.com/',
  stage: 'https://eems-stage-online.optum.com/',
  adop: 'https://eems-adop-online.optum.com/',
  prod: 'https://eems-prod-online.optum.com/',
};

export const getEnvironment = () => {
  switch (true) {
    case window.location.hostname.includes('uata'):
      return 'uata';
    case window.location.hostname.includes('sita'):
      return 'sita';
    case window.location.hostname.includes('sitb'):
      return 'sitb';
    case window.location.hostname.includes('uatb'):
      return 'uatb';
    case window.location.hostname.includes('stage'):
      return 'stage';
    case window.location.hostname.includes('adop'):
      return 'adop';
    case window.location.hostname.includes('adp'):
      return 'adop';
    case window.location.hostname.includes('prod'):
      return 'prod';
    case window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1':
      return 'stage';
    default:
      return 'uata';
  }
};

export const getEEMSURL = () => {
  return eemsURL[getEnvironment()];
};

export const isLocalhost = () =>
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1';

export const getServiceURL = () => {
  // Local dev goes through the same-origin `abyss dev` proxy (/api -> stage, see .abyss/settings.json)
  // because the backend has no CORS for localhost and its auth cookie must be set on localhost.
  if (isLocalhost()) return `${window.location.origin}/api/`;
  return serviceURL[getEnvironment()];
};
